import { SchedulerViewPresets } from '@cbgms/components/scheduler/components/BryntumScheduler'
import { IGmsSchedulerStateBase } from 'app/scheduler/types'
import { GmsSchedulerPages, GmsSchedulerViewModes, SchedulerDaysToShowByViewSettings } from '@cbgms/api/modules/scheduler'

export const schedulerDefaultState: IGmsSchedulerStateBase = {
  viewPreset: SchedulerViewPresets.HOUR_ADN_DAY_PRESET,
  barMargin: 5,
  eventsVersion: 1,
  resourcesVersion: 1,
  events: [],
  resources: [],
  workstations: [],
  mechanics: []
}

export const schedulerDefaultSettings = {
  WorkDays: 5,
  HidePreviousDayInOverview: false,
  DaysToShowByView: {
    [SchedulerDaysToShowByViewSettings.Dashboard]: 3,
    [SchedulerDaysToShowByViewSettings.MainMechanics]: 5,
    [SchedulerDaysToShowByViewSettings.MainWeek]: 5,
    [SchedulerDaysToShowByViewSettings.MainWorkstations]: 5,
    [SchedulerDaysToShowByViewSettings.PlanningMechanics]: 5,
    [SchedulerDaysToShowByViewSettings.PlanningWorkstations]: 5,
    [SchedulerDaysToShowByViewSettings.PlanningWeek]: 5
  },
  LastVisitedViewByPage: {
    [GmsSchedulerPages.DASHBOARD]: GmsSchedulerViewModes.DEFAULT,
    [GmsSchedulerPages.MAIN]: GmsSchedulerViewModes.DEFAULT,
    [GmsSchedulerPages.PLANNING]: GmsSchedulerViewModes.DEFAULT
  }
}
